export default __webpack_public_path__ + "static/media/icon-card-hydraulics.7dbab33e.svg";